import React, { PropsWithChildren } from 'react'

import { Body2 } from '@ui/Typography'
import { IconFCType } from '@ui/icons/types'

import { Box } from '@shared/components/Box'

export interface ButtonWithSideProps extends PropsWithChildren {
  icon: IconFCType
  text: string
  fullWidth?: boolean
}

export const ButtonWithSide: React.FC<ButtonWithSideProps> = ({
  icon: Icon,
  text,
  children,
  fullWidth = false,
}) => {
  return (
    <Box flex border='outline-med-em' radius='x32' fullWidth={fullWidth} gap='x16' pl='x16'>
      <Box flex align='center' gap='x8'>
        <Icon color='text-med-em' size={16} />
        <Body2 whiteSpace='nowrap' color='text-med-em'>
          {text}
        </Body2>
      </Box>
      {children}
    </Box>
  )
}
